import { CardSelectOption } from "ui/components/CardSelect/types";
import {
  DriverSourceEnum,
  FleetVehicleDriverEditFormValues,
} from "services/api/fleet/vehicles/drivers/types";

/**
 * Odakle dolazi vozač. Odluka se donosi ovdje, pri unosu vozača — ostatak aplikacije
 * poslije barata samo vozačem.
 */
export const DRIVER_SOURCE_OPTIONS: CardSelectOption[] = [
  {
    id: DriverSourceEnum.USER,
    icon: "/media/icons/users.svg",
    title: "Korisnik aplikacije",
    description: "Vozač je netko od korisnika",
  },
  {
    id: DriverSourceEnum.CONTACT,
    icon: "/media/icons/contact.svg",
    title: "Kontakt",
    description: "Vozač iz imenika — dobavljač, serviser, klijent",
  },
];

/**
 * Isprava vozača kao korak čarobnjaka. Sve tri nose isto — broj, rok i presliku — pa ih
 * crta jedna komponenta, a razlikuje ih samo ovaj opis.
 */
export interface DriverDocumentStep {
  title: string;
  description: string;
  numberLabel: string;
  expiryLabel: string;
  emptyText: string;
  numberField: keyof Pick<
    FleetVehicleDriverEditFormValues,
    "driversLicenceNumber" | "identityCardNumber" | "passportNumber"
  >;
  expiryField: keyof Pick<
    FleetVehicleDriverEditFormValues,
    "driversLicenceExpiry" | "identityCardExpiry" | "passportExpiry"
  >;
  uploadsField: keyof Pick<
    FleetVehicleDriverEditFormValues,
    "driversLicenceUploads" | "identityCardUploads" | "passportUploads"
  >;
}

export const DRIVER_DOCUMENT_STEPS: DriverDocumentStep[] = [
  {
    title: "Vozačka dozvola",
    description: "Broj i rok vrijedenja, uz presliku dozvole.",
    numberLabel: "Broj vozačke",
    expiryLabel: "Vrijedi do",
    emptyText: "Priložite presliku vozačke dozvole",
    numberField: "driversLicenceNumber",
    expiryField: "driversLicenceExpiry",
    uploadsField: "driversLicenceUploads",
  },
  {
    title: "Osobna iskaznica",
    description: "Broj i rok vrijedenja, uz presliku iskaznice.",
    numberLabel: "Broj osobne",
    expiryLabel: "Vrijedi do",
    emptyText: "Priložite presliku osobne iskaznice",
    numberField: "identityCardNumber",
    expiryField: "identityCardExpiry",
    uploadsField: "identityCardUploads",
  },
  {
    title: "Putovnica",
    description: "Broj i rok vrijedenja, uz presliku putovnice.",
    numberLabel: "Broj putovnice",
    expiryLabel: "Vrijedi do",
    emptyText: "Priložite presliku putovnice",
    numberField: "passportNumber",
    expiryField: "passportExpiry",
    uploadsField: "passportUploads",
  },
];
